// =============================================================================
// BucketColorLegend: QA #17 — "I don't know what the different colors are…
// can't just be pretty" (Jason, on the score rings + bucket chips having no
// stated meaning). A plain, honest KEY: one swatch + label + the SAME `note`
// copy BucketFilterChips already uses as its chip tooltip, so a first-time
// user reading the legend gets the identical explanation a chip's title
// attribute gives on hover — one source of truth (jobBuckets.ts's
// BUCKET_CHIPS), never a second, drifting copy of what each color means.
//
// LANE W2.1-BUCKETS: renders all SEVEN BUCKET_CHIPS rows, including
// 'undetermined' (BUCKET_CHIPS' synthetic entry for a null/never-scored
// job). BUG-2026-07-08 PACKAGE E: 'undetermined' used to share BOTH the
// label ("Unsorted") AND the color token with the real 'unsorted' bucket, so
// it was deliberately filtered out of this legend to avoid a duplicate row —
// but that was the SAME bug Jason flagged on the filter chips themselves
// ("two unsorted tabs... Unacceptable"), just hidden here instead of fixed.
// Now that 'undetermined' carries its OWN label ("New") and its OWN color
// token (--tl-bucket-undetermined), it is real, distinct information and
// belongs in the legend like every other row — no more filter.
//
// Reads its swatch color from BucketChipConfig.colorVar — the SAME CSS
// variable JobCard.module.css's `[data-bucket=...]` selectors resolve for the
// actual per-card chip, so the legend can never show a color the real chips
// don't also use. LANE W2.1-BUCKETS (Jason, direct: "I want a different color
// on each as well"): colorVar now resolves one of SEVEN distinct
// --tl-bucket-* tokens (theme/themes.ts) — no two rows in this legend ever
// render the same swatch color.
// =============================================================================

import { BUCKET_CHIPS } from '../lib/jobBuckets';
import styles from './BucketColorLegend.module.css';

const LEGEND_CHIPS = BUCKET_CHIPS;

export function BucketColorLegend() {
  return (
    <div className={styles.legend} role="note" aria-label="What the bucket colors mean">
      <div className={styles.legendTitle}>What the colors mean</div>
      <div className={styles.legendRow}>
        {LEGEND_CHIPS.map((chip) => (
          <div key={chip.key} className={styles.legendItem} title={chip.note}>
            <span className={styles.swatch} style={{ background: `var(${chip.colorVar})` }} aria-hidden="true" />
            <span className={styles.legendLabel}>{chip.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
